import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDestinationList = createAsyncThunk("fetchDestinationList", async () => {
    try {
        const response = await axiosHttp.get(`requests/destination`);
        return response.data.data;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
});

const DestinationListSlice = createSlice({
    name: "DestinationListSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null
    },

    extraReducers: (builder) => {
        builder.addCase(fetchDestinationList.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchDestinationList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchDestinationList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default DestinationListSlice.reducer;
